module.exports = __webpack_public_path__ + "assets/images/yellow1_7555ec99750e1bb0a68583bbe5b0bb40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/yellow1.png
// module id = 153
// module chunks = 0